/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
import React from 'react';
import Popper from '@mui/material/Popper';
import {ComponentPaperAutocomplete, CustomPopperAutocompleteStyle} from "./Styles";
import Paper from "@mui/material/Paper";


export const CustomPopperAutocomplete = (props) => {
    return (
        <Popper
            {...props}
            style={CustomPopperAutocompleteStyle}
            className={"mt-3"}
            placement="bottom-start"
            modifiers={[
                {
                    name: 'offset',
                    options: {
                        offset: [0, 4],
                    },
                },
                {
                    name: "sameWidth",
                    enabled: true,
                    phase: "beforeWrite",
                    requires: ["computeStyles"],
                    fn: ({ state }) => {
                        if (state.rects.reference.width < 400 ) {
                            state.styles.popper.width = `${state.rects.reference.width}px`;
                        } else {
                            state.styles.popper.width = CustomPopperAutocompleteStyle.customWidth;
                        }
                    },
                },
            ]}
        />
    );
};

export const CustomPaperAutocomplete = (props) => {
    return <Paper
        {...props}
        elevation={3}
        square={false}
        sx={ComponentPaperAutocomplete}
    />;
};
